import { render } from "./JumpPurchaseView.vue?vue&type=template&id=2cf9275a"
import script from "./JumpPurchaseView.vue?vue&type=script&lang=js"
export * from "./JumpPurchaseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__